import { CheckCircle2 } from 'lucide-react';
import { PROCESS_STEPS } from '../data';

export default function ProcessSection() {
  return (
    <section className="py-20 bg-stone-100 text-stone-900 border-y border-stone-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <h2 className="font-heading font-extrabold text-3xl sm:text-4xl text-stone-900 tracking-tight uppercase">
            Sådan arbejder vi
          </h2>
          <p className="text-stone-600 text-base mt-3">
            Fra første idé og rådgivning til det færdige håndværk leveret til tiden.
          </p>
        </div>

        {/* Process Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {PROCESS_STEPS.map((item) => (
            <div 
              key={item.step}
              className="bg-white p-8 border border-stone-200 shadow-sm relative flex flex-col justify-between"
            >
              <div>
                <span className="font-heading font-black text-4xl text-stone-900 block mb-4 tracking-tighter">
                  {item.step}
                </span>
                <h3 className="font-heading font-bold text-lg text-stone-900 mb-2 uppercase">
                  {item.title}
                </h3>
                <p className="text-stone-600 text-sm leading-relaxed">
                  {item.description}
                </p>
              </div>
              <div className="mt-6 pt-4 border-t border-stone-100 text-xs font-semibold uppercase tracking-wider text-stone-800 flex items-center gap-1.5">
                <CheckCircle2 className="w-4 h-4 text-stone-900 shrink-0" />
                <span>Garanteret Forløb</span>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
